import { render, staticRenderFns } from "./ProfileComplete.vue?vue&type=template&id=a960e892&"
import script from "./ProfileComplete.vue?vue&type=script&lang=js&"
export * from "./ProfileComplete.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports